import React, { useEffect, useState } from 'react';
// import { Box } from '@mui/material';
import { Error } from '../../../../components';
import { CircularProgress, TextField } from '@material-ui/core';
import Grid from '@mui/material/Grid';

import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { axios } from '@/services/axios';
import { Box, Heading } from '@chakra-ui/react';
import { NonNegativeInteger } from 'components/maintenance/NumberFormatCustom';
import EditTrunkAdminTab from './EditTrunkAdminTab';
import { useDispatch, useSelector } from 'react-redux';
import { TabContext, TabPanel } from '@material-ui/lab';
import { toast } from 'react-toastify';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const EditExtTrunk = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [errorState, setErrorState] = useState(false);
    const [errorDialog, setErrorDialog] = useState(null);
    const [tabView, setTabView] = useState(0);

    const [trunk, setTrunk] = useState(null);
    const [title, setTitle] = useState('');

    const [minChannels, setMinChannels] = useState(null);
    const [incSize, setIncSize] = useState(null);

    // state access
    const { state } = useSelector((state) => {
        return {
            ...state.modal,
        };
    });

    const { currentCompany } = useSelector((state) => ({
        ...state.navigationLists,
    }));

    const handleBackbutton = () => {
        navigate('/trunks');
        dispatch({
            type: 'RESET_MODAL',
        });
    };

    const handleTabChange = (e, value) => {
        setTabView(value);
    };

    const statusToString = (status) => {
        switch (status) {
            case 0:
                return 'OK';
            case 1:
                return 'Adding';
            case 3:
                return 'Pending Approval';
            case 4:
                return 'Updating';
            case 8:
                return 'Degraded';
            case 9:
                return 'Deleting';
            default:
                return 'Error';
        }
    };

    useEffect(() => {
        if (id) {
            axios
                .get(`/Trunk/${id}`)
                .then((res) => {
                    dispatch({
                        type: 'CHANGE_MODAL_STATE',
                        payload: {
                            ...res.data,
                        },
                    });
                    setTitle(
                        'Edit Trunk -> ' +
                            res.data.sipHeader +
                            ' -> Status: ' +
                            statusToString(res.data.status),
                    );
                    setMinChannels(res.data.trunkType?.minChannels);
                    setIncSize(res.data.trunkType?.incSize);
                    setIsLoading(false);
                })
                .catch((err) => {
                    setErrorDialog(err);
                    setErrorState(true);
                    setIsLoading(false);
                });
        }
    }, [id]);

    // editing a trunk api call
    const handleEditTrunk = () => {
        setErrorDialog(null);
        setErrorState(false);
        setIsLoading(true);
        axios
            .post(
                '/trunk/name',
                {
                    trunkId: state.id,
                    trunkName: state.name,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            )
            .then(() => {
                axios
                    .post(
                        '/trunk/channels',
                        {
                            trunkId: state.id,
                            channels: state.channels,
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        },
                    )
                    .then(() => {
                        navigate(`/trunks`);
                        dispatch({
                            type: 'RESET_TABLE',
                        });
                        dispatch({
                            type: 'RESET_MODAL',
                        });
                    })
                    .catch((err) => {
                        toast.error(err.response.data.message);
                        setIsLoading(false);
                        return;
                    });
            })
            .catch((e) => {
                toast.error(e.response.data.message);
                setIsLoading(false);
            });
    };

    // reset navigation on wholesaler/company change
    if (state?.companyID !== currentCompany) {
        navigate('/trunks');
    }

    return isLoading ? (
        <CircularProgress style={{ marginTop: '2.5%', marginLeft: '50%' }} />
    ) : (
        <>
            <Heading fontSize="3xl" as="h2" mb={'1%'}>
                <span className="text-2xl font-semibold">{title}</span>
            </Heading>
            <TabContext value={tabView}>
                <Box
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'brand.500',
                        },
                    }}>
                    <Tabs
                        value={tabView}
                        centered
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleTabChange}>
                        <Tab
                            sx={{ textTransform: 'none', minWidth: '160px' }}
                            label="General"
                            key="General"
                        />
                        <Tab
                            sx={{ textTransform: 'none', minWidth: '160px' }}
                            label="Admin"
                            key="Admin"
                        />
                    </Tabs>
                    <TabPanel
                        className="MuiTypography-body1"
                        style={{ display: tabView === 0 ? 'block' : 'none' }}
                        value={tabView}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid
                                container
                                xs={12}
                                style={{ maxWidth: '896px' }}
                                className="mx-auto flex justify-center">
                                {/* Trunk Name */}
                                <Grid item xs={6}>
                                    <TextField
                                        sx={{ paddingTop: 0.6 }}
                                        id="TrunkName"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        label="Trunk Name"
                                        size="small"
                                        value={state.name}
                                        onChange={(e) => {
                                            dispatch({
                                                type: 'CHANGE_MODAL_STATE',
                                                payload: {
                                                    name: e.target.value,
                                                },
                                            });
                                        }}
                                    />
                                </Grid>

                                {/* Channels */}
                                <Grid item xs={6}>
                                    <TextField
                                        sx={{ paddingTop: 0.6 }}
                                        id="Channels"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        label="Channels"
                                        size="small"
                                        value={state.channels}
                                        onChange={(e) => {
                                            dispatch({
                                                type: 'CHANGE_MODAL_STATE',
                                                payload: {
                                                    channels: e.target.value,
                                                },
                                            });
                                        }}
                                        InputProps={{
                                            inputComponent: NonNegativeInteger,
                                        }}
                                        helperText={`Minimum channels is ${minChannels} in increments of ${incSize}`}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </TabPanel>
                    <TabPanel
                        className="MuiTypography-body1"
                        style={{ display: tabView === 1 ? 'block' : 'none' }}
                        value={tabView}>
                        <EditTrunkAdminTab trunkValid={true} />
                    </TabPanel>
                </Box>
            </TabContext>

            <div
                style={{
                    border: 'none',
                    textAlign: 'center',
                    justifyContent: 'center',
                    marginBottom: 10,
                }}>
                <Button
                    className="min-w-[5rem]"
                    variant="secondary"
                    onClick={handleBackbutton}>
                    Back
                </Button>
                <div style={{ marginLeft: 10, display: 'inline' }}>
                    <Button
                        className="min-w-[5rem]"
                        variant="primary"
                        type="submit"
                        onClick={handleEditTrunk}>
                        Update
                    </Button>
                </div>
            </div>
        </>
    );
};

export default EditExtTrunk;
